module.exports = __webpack_public_path__ + "img/fruit_lyme.8b1aeb0d.png";